<template>
  <tr>
    <td data-label="Name">
      <strong>
        <span v-if="birthday" class="fa fa-lg fa-birthday-cake text-pink"></span>
        {{ manager.fullName }}
        <br />
        ({{ manager.username }})
      </strong>
    </td>
    <td data-label="Title">
      {{ manager.positionTitle }}
    </td>
    <td data-label="Email">
      <a :href="'mailto:' + manager.email" target="_top">
        {{ manager.email }}
      </a>
    </td>
    <td data-label="Mobile">
      <a :href="'tel:' + mobile">
        {{ manager.phone }}
      </a>
    </td>
    <td data-label="Phone (BH)">
      <a :href="'tel:' + businessPhone">
        {{ manager.businessPhone }}
      </a>
    </td>
    <td data-label="Company">
      <router-link
        v-if="manager.Company"
        :to="'/database-manager/companies/' + manager.Company.uuid">
        {{ manager.Company.name }}
      </router-link>
    </td>
    <td>
      <button class="my-2 btn btn-warning" @click="editCode()">
        <i class="fa fa-edit" /> Edit
      </button>
      <button class="my-2 btn btn-danger" @click="deleteCode()">
        <i class="fa fa-trash" /> Delete
      </button>
      <download-input
        :options="{ label: 'Download vCard', permalink: 'downloadVCard', button: true }"
        :value="{ uuid: manager.uuid }" />
    </td>
  </tr>
</template>

<script>
import DownloadInput from '@/components/inputs/DownloadInput'
export default {
  name: 'OcManagerRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  components: {
    DownloadInput
  },
  computed: {
    birthday () {
      if (this.manager.dateOfBirth) {
        return moment().format('DD-MM') === moment(this.manager.dateOfBirth).format('DD-MM')
      } else {
        return false
      }
    },
    mobile () {
      if (this.manager.phone) {
        return this.manager.phone.replace(/\D/g, '')
      } else {
        return ''
      }
    },
    businessPhone () {
      if (this.manager.businessPhone) {
        return this.manager.businessPhone.replace(/\D/g, '')
      } else {
        return ''
      }
    },
    manager () {
      return {
        Company: {},
        ...this.object
      }
    }
  },
  methods: {
    editCode () {
      this.$emit('edit', { permalink: 'editManager', uuid: this.manager.uuid })
    },
    deleteCode () {
      this.$emit('deleteObject', { permalink: 'deleteManager', uuid: this.manager.uuid })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/OcManager.vue